export enum SpecialOfferPriceTypeEnum {
    FIXED = 'Fixed',
    FREE = 'Free',
    POA = 'P.O.A',
    FROM = 'From'
}